import React from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import s from './studentPerformanceByAssignmentComponent.module.css';
import { AQUA_BASE } from '../../../reports-constants.js';
import { useLaunchUrl } from '../../../contexts/LaunchContext.jsx';
import { getAVGScoreColumn } from '../../QuantQual/qqComponents/componentFunctions';
import { clickByAssignment } from '../../../../analyticsEvents.js';

import PaginatedTable from '../../../../../components/PaginatedTable/PaginatedTable';

const performanceByAssignmentComponentStudents = ({ data, courseId, onTabChange, reportType, sendEvent }) => {
  const getLaunchUrl = useLaunchUrl();

  const dispatch = useDispatch();

  const handleAssignmentClick = () => {
    dispatch(sendEvent(clickByAssignment(reportType)));
  };

  const tableStyle = [
    {
      row: 'styledRow',
      cells: [
        { accessor: 'name', color: AQUA_BASE },
        { accessor: 'startedQuestions', alignment: 'right' },
        { accessor: 'averageAchievement', alignment: 'right' },
        { accessor: 'correctOnFirstTry', alignment: 'right' },
      ],
    },
  ];

  const tableColumns = [
    {
      accessor: 'name',
      Header: 'Assignment Title',
      cell: (item) => {
        const dataForGetLaunch = {
          tab: 'reports/type/submodule',
          tool: item.tool,
          activity_id: item.activityId,
          id: item.id,
          course_id: courseId,
        };
        return (
          <div>
            <a onClick={handleAssignmentClick} href={getLaunchUrl(dataForGetLaunch)} >{item.name}</a>
            <span>{`Due ${moment(item.dueDate).format('ll [at] LT')} `}</span>
          </div>
        );
      },
    },
    {
      accessor: 'startedQuestions',
      Header: 'Questions Started',
      cell: item => (
        <div>{item.startedQuestions < 0 ? '—' : `${item.startedQuestions}`}</div>
      ),
    },
    {
      accessor: 'averageAchievement',
      Header: 'Student Achievement',
      cell:
        (item) => {
          if (item.averageAchievement < 0) {
            return <div>—</div>;
          }
          return (
            <div className={s.averageAchievement}>
              <div>{`(${item.assignmentType} assignment)`} </div>
              <div>{`${Math.round(item.averageAchievement * 100)}%`}</div>
            </div>
          );
        },
    },
    {
      accessor: 'correctOnFirstTry',
      Header: 'Questions Correct on First Try',
      cell:
        item => getAVGScoreColumn(item, 'correctOnFirstTry'),
    },
  ];

  const modalContent = (
    <div className={s.modal}>
      <p><b>Questions started</b> represents the number of questions on this  assignment that this student began out of the number that were assigned to them.</p>
      <p><b>Student achievements</b> is the score that the student got on the assignment. There are two types of achievement scores:<br /></p>
      <div>
        <p><b>Completion assignments</b> are either assigned readings or assessments (such as practices quizzes or homework assignments) where students are granted multiple
         attempts on each question to help them build content understanding.<br /></p>
        <p><b>Proficiency assignments</b> are assessments (such as practices quizzes or tests) where students are granted only one attempt on each question to measure content proficiency.</p>
      </div>
      <p><b>Questions correct on first try</b> represents, across all questions on this assignment answered by the student, the proportion that were correct on a student&#39;s first try.<br /></p>
    </div>
  );

  const nullStateContent = (
    <p>
      There are no assignments covering this subunit.<br />
      Go to <button role="link" className={s.nullState} onClick={() => { onTabChange('assignments'); }}>Course Planner</button> tab to setup and manage assignments.
    </p>
  );

  return (
    <div className={s.performanceByAssignmentStudent} data-test-id={`${reportType}-performance-by-assignment`}>
      <PaginatedTable
        id="performanceByAssignmentCard"
        className={s.performanceCard}
        title="Performance by Assignment"
        data={data}
        tableStyle={tableStyle}
        tableColumns={tableColumns}
        sortBy={['correctOnFirstTry', 'name']}
        direction="ascending"
        modalContent={modalContent}
        nullState={nullStateContent}
        styleFunction={() => 'styledRow'}
        reportType={reportType}
      />
    </div>
  );
};

export default performanceByAssignmentComponentStudents;
